import {
  INTERPRETER_CALL_TYPE_SELECTED,
  INTERPRETER_GENDER_SELECTED,
  INTERPRETER_INVITE_REQUEST_ID,
  INTERPRETER_LANGUAGE_SELECTED,
  INTERPRETER_LANGUAGE_UPDATED,
  INTERPRETER_INVITE_STATUS,
  INTERPRETER_INVITE_NOTIFICATION_ID,
  INTERPRETER_INVITE_RETRY_NOTIFCATION_ID,
  INTERPRETER_GENDER_OPTION_UPDATED,
  INTERPRETER_CALL_TYPE_UPDATED,
  INTERPRETER_ESTIMATED_TIME,
  INTERPRETER_ESTIMATED_TIME_AVAILABLE,
} from "../actions/types/interpreter";

const initialState = {
  callType: 1,
  selectedGender: { text: "NO_PREFERRENCE", value: 5 },
  selectedLanguage: { text: "SELECT_LANGUAGE_PLACEHOLDER" },
  vendorLanguage: [],
  genderOptionList: [],
  callTypeList: [],
  interpreterSessionID: null,
  interpreterRequestIsInProgress: false,
  retryNotifcationID: null,
  notificationID: null,
  estimatedTime: "We are calculating your estimated waiting time.",
  isEstimatedTimeAvailable: true,
};

const interpreter = (state = initialState, action) => {
  switch (action.type) {
    case INTERPRETER_CALL_TYPE_SELECTED: {
      return {
        ...state,
        callType: action.payload,
      };
    }
    case INTERPRETER_GENDER_SELECTED: {
      return {
        ...state,
        selectedGender: action.payload,
      };
    }
    case INTERPRETER_LANGUAGE_SELECTED: {
      return {
        ...state,
        selectedLanguage: action.payload,
      };
    }
    case INTERPRETER_LANGUAGE_UPDATED: {
      return {
        ...state,
        vendorLanguage: action.payload,
      };
    }
    case INTERPRETER_INVITE_REQUEST_ID: {
      return {
        ...state,
        interpreterSessionID: action.payload,
      };
    }

    case INTERPRETER_INVITE_STATUS: {
      return {
        ...state,
        interpreterRequestIsInProgress: action.payload,
      };
    }

    case INTERPRETER_INVITE_RETRY_NOTIFCATION_ID: {
      return {
        ...state,
        retryNotifcationID: action.payload,
      };
    }

    case INTERPRETER_INVITE_NOTIFICATION_ID: {
      return {
        ...state,
        notificationID: action.payload,
      };
    }

    case INTERPRETER_GENDER_OPTION_UPDATED: {
      return {
        ...state,
        genderOptionList: action.payload,
      };
    }

    case INTERPRETER_CALL_TYPE_UPDATED: {
      return {
        ...state,
        callTypeList: action.payload,
      };
    }

    case INTERPRETER_ESTIMATED_TIME: {
      return {
        ...state,
        estimatedTime: action.payload,
      };
    }

    case INTERPRETER_ESTIMATED_TIME_AVAILABLE: {
      return {
        ...state,
        isEstimatedTimeAvailable: action.payload,
      };
    }

    default:
      return state;
  }
};

export default interpreter;
